<template>
  <v-dialog
    class="elevation-0 rounded-0"
    v-model="wlOpen"
    width="650px"
    persistent
  >
    <v-card class="elevation-0 rounded-0">
      <v-toolbar class="elevation-0 rounded-0" color="#f7f7f7" dense>
       White List Config

        <v-spacer></v-spacer>

        <v-btn
          small
          class="elevation-0 rounded-0"
          icon
          @click="closewlModal()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-toolbar v-if="wlData" color="#FFFF" class="elevation-0 rounded-0">
        <v-toolbar-subtitle style="text-align: left"
          >{{ wlData.vessel_number }}
          <br />
          <div v-if="wlData" style="text-align: left">
            <v-chip
              v-if="wlData.latest_status == 'FAILED'"
              class="ma-0 elevation-0 rounded-0"
              color="red"
              x-small
              label
              text-color="white"
            >
              <v-icon x-small left> mdi-close-thick </v-icon>
              Failed to change Settings at {{ wlData.last_updated }}, please
              resubmit
            </v-chip>
            <v-chip
              v-if="wlData.latest_status == 'ON AIR'"
              class="ma-0 elevation-0 rounded-0"
              color="yellow"
              x-small
              label
              text-color="black"
            >
              <v-icon x-small left> mdi-clock </v-icon>
              Waiting for Confirmation, sent at {{ wlData.last_updated }}
            </v-chip>
            <v-chip
              v-if="wlData.latest_status == 'CONFIRMED'"
              class="ma-0 elevation-0 rounded-0"
              color="green"
              x-small
              label
              text-color="white"
            >
              <v-icon x-small left> mdi-check-bold </v-icon>
              Updated at {{ wlData.last_updated }}
            </v-chip>
          </div>
        </v-toolbar-subtitle>

        <v-spacer></v-spacer>
      </v-toolbar>
      <v-divider v-if="wlData"></v-divider>

      <v-container style="margin-top: 0" v-if="!wlmodal" fill-height fluid>
        <v-row align="center" justify="center">
          <v-col
            ><img
              alt="Navplus logo"
              width="70px"
              :src="loadernavplus"
              class="justify-center"
          /></v-col>
        </v-row>
      </v-container>

      <v-card-text
      v-if="wlmodal"
        id="div_wl"
        :style="wlData ? 'height:450px' : ''"
        width="100"
        class="overflow-y-auto"
      >
      <v-container style="margin-top: 2em" v-if="!wlData" fill-height fluid>
          <v-row align="center" justify="center">
            <v-col
              ><img
                alt="Navplus logo"
                width="70px"
                :src="loadernavplus"
                class="justify-center"
            /></v-col>
          </v-row>
        </v-container>
      <div
        v-if="wlData && wlData.latest_status != 'ON AIR'"
        class="mt-10"
      >
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="1" style="min-width: 9rem; max-width: 40%; margin: 5px">
            <v-row v-for="(item, i) in wlData.latest_names" :key="i">
              <v-col style="margin-top: -35px">
                <v-text-field
                  class="elevation-0 rounded-0 ma-0"
                  :value="'ReciPient ' + (a = i + 1)"
                  filled
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="1"
            style="min-width: 100px; max-width: 100%; margin: 5px"
            class="flex-grow-1 flex-shrink-0"
          >
            <v-row v-for="(item, i) in wlData.latest_names" :key="i">
              <v-col style="margin-top: -35px">
                <v-text-field
                  class="elevation-0 rounded-0"
                  v-model="wlData.latest_names[i]"
                  :value="item"
                  :placeholder="'Name ' + (a = i + 1)"
                  @input="checkdata('latest_names', i)"
                  :filled="
                    item == 'NOC 1' && i == 0
                      ? true
                      : false || (item == 'NOC 2' && i == 1)
                      ? true
                      : false || (item == 'NOC 3' && i == 2)
                      ? true
                      : false || (item == 'NOC 4' && i == 3)
                      ? true
                      : false || (item == 'NOC 5' && i == 4)
                      ? true
                      : false || (item == 'NOC 6' && i == 5)
                      ? true
                      : false || user_allowed.allowed['edit whitelist contact']
                      ? false
                      : true
                  "
                  outlined
                  :readonly="
                    item == 'NOC 1' && i == 0
                      ? true
                      : false || (item == 'NOC 2' && i == 1)
                      ? true
                      : false || (item == 'NOC 3' && i == 2)
                      ? true
                      : false || (item == 'NOC 4' && i == 3)
                      ? true
                      : false || (item == 'NOC 5' && i == 4)
                      ? true
                      : false || (item == 'NOC 6' && i == 5)
                      ? true
                      : false || user_allowed.allowed['edit whitelist contact']
                      ? false
                      : true
                  "
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="1"
            style="min-width: 100px; max-width: 100%; margin: 5px"
            class="flex-grow-1 flex-shrink-0"
          >
            <v-row v-for="(item, i) in wlData.latest_content" :key="i">
              <v-col style="margin-top: -35px">
                <v-text-field
                  class="elevation-0 rounded-0"
                  v-model="wlData.latest_content[i]"
                  @input="checkdata('latest_content', i)"
                  :value="item"
                  :placeholder="'Number ' + (a = i + 1)"
                  :filled="
                    wlData.latest_names[i] == 'NOC 1' && i == 0
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 2' && i == 1)
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 3' && i == 2)
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 4' && i == 3)
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 5' && i == 4)
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 6' && i == 5)
                      ? true
                      : false || user_allowed.allowed['edit whitelist contact']
                      ? false
                      : true
                  "
                  outlined
                  :readonly="
                    wlData.latest_names[i] == 'NOC 1' && i == 0
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 2' && i == 1)
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 3' && i == 2)
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 4' && i == 3)
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 5' && i == 4)
                      ? true
                      : false || (wlData.latest_names[i] == 'NOC 6' && i == 5)
                      ? true
                      : false || user_allowed.allowed['edit whitelist contact']
                      ? false
                      : true
                  "
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-btn
          small
          :disabled="changes_ ? false : true"
          class="elevation-0 rounded-0"
          @click="
            user_allowed.allowed['edit whitelist contact']
              ? wlDataPost()
              : console.log('disabled')
          "
          :color="
            user_allowed.allowed['edit whitelist contact']
              ? 'primary'
              : '#9CBDDE'
          "
          :style="
            user_allowed.allowed['edit whitelist contact']
              ? 'cursor:pointer'
              : 'cursor:not-allowed'
          "
          block
        >
          Update White List Configuration
        </v-btn>
      </div>
      <div
        v-if="wlData && wlData.latest_status == 'ON AIR'"
        class="mt-10"
      >
        <v-row no-gutters style="flex-wrap: nowrap">
          <v-col cols="1" style="min-width: 9rem; max-width: 40%; margin: 5px">
            <v-row v-for="(item, i) in wlData.latest_names" :key="i">
              <v-col style="margin-top: -35px">
                <v-text-field
                  class="elevation-0 rounded-0"
                  :placeholder="'RecePient ' + (a = i + 1)"
                  filled
                  outlined
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="1"
            style="min-width: 100px; max-width: 100%; margin: 5px"
            class="flex-grow-1 flex-shrink-0"
          >
            <v-row v-for="(item, i) in wlData.latest_names" :key="i">
              <v-col style="margin-top: -35px">
                <v-text-field
                  class="elevation-0 rounded-0"
                  v-model="wlData.latest_names[i]"
                  filled
                  :value="item"
                  :placeholder="'Name ' + (a = i + 1)"
                  disabled
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="1"
            style="min-width: 100px; max-width: 100%; margin: 5px"
            class="flex-grow-1 flex-shrink-0"
          >
            <v-row v-for="(item, i) in wlData.latest_content" :key="i">
              <v-col style="margin-top: -35px">
                <v-text-field
                  class="elevation-0 rounded-0"
                  v-model="wlData.latest_content[i]"
                  :value="item"
                  :placeholder="'Number ' + (a = i + 1)"
                  filled
                  disabled
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-btn
          disabled
          small
          style="cursor: not-allowed"
          class="elevation-0 rounded-0"
          color="#7CB7E8"
          block
        >
          Update White List Configuration
        </v-btn>
      </div>
    </v-card-text>

 
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "../../utils/axios";
import $ from "jquery";
export default {
  data() {
    return {
      wlmodal: null,
      change: false,
      loadernavplus: require("@/assets/img/load100new.gif"),
      fetchInterval: null,
    };
  },
  mounted() {
    this.wlFetchStatic();
  },
  methods: {
    ...mapActions(["wlModal", "wlFetch", "wlPost", "wlRemove"]),

      closewlModal() {
      this.wlRemove();
      this.stopFetch();
    },

    checkdata(statis, value) {
      console.log(value);
      console.log(this.wlmodal[statis][value]);
      console.log(this.wlData[statis][value]);
      if (this.wlmodal[statis][value] == this.wlData[statis][value]) {
        this.change = false;
      } else {
        this.change = true;
      }
    },
    async wlDataPost() {
      $("#div_wl").scrollTop(0);
      this.change = false;
      const data = {
        thuraya_number: this.wlData.number,
        recipients: this.wlData.latest_content,
        names: this.wlData.latest_names,
        token: localStorage.getItem("token"),
      };
      this.wlPost(data);

      var mother = this;
      var intervalSeconds = 0.5;
      this.fetchInterval = setInterval(function () {
        mother.wlDataFetch();
      }, intervalSeconds * 1000);
    },

    stopFetch() {
      console.log("STOP FETCH STATUS WHITELIST");
      clearInterval(this.fetchInterval);
      this.on = false;
    },

    async wlDataFetch() {
      console.log("FETCH TERUS STATUS WHITELIST");
      console.log("STATUS :");
      const data = {
        id: this.wlID,
        token: localStorage.getItem("token"),
      };
      this.wlFetch(data);
      var mother = this;
      setTimeout(function () {
        if (mother.wlData) {
          if (mother.wlData.latest_status != "ON AIR") {
            mother.stopFetch();
            mother.wlFetchStatic();
          }
        } else {
          if (mother.wlmodal.latest_status != "ON AIR") {
            mother.stopFetch();
            mother.wlFetchStatic();
          }
        }
      }, 5000);
    },

    async wlFetchStatic() {
      console.log(this.wlID);
      try {
        const response = await axios.get(
          "/api/v1/navplus/thuraya/" + this.wlID + "/whitelist",
          {
            headers: {
              Authorization: "Bearer" + localStorage.getItem("token"),
            },
          }
        );

        console.log(response);

        this.wlmodal = response.data.data;
        var mother = this;
        var intervalSeconds = 0.5;
        if (response.data.data.latest_status == "ON AIR") {
          this.fetchInterval = setInterval(function () {
            mother.wlDataFetch();
          }, intervalSeconds * 1000);
        }
      } catch (e) {
        console.log(e);
      }
    },
  },

  computed: {
    ...mapGetters(["wlData", "wlID", "wlOpen", "user_allowed"]),
    changes_() {
      return this.change;
    },
  },
};
</script>

<style lang="scss" scoped></style>
